module.exports = __webpack_public_path__ + "img/one-key.ea1967c7.png";